import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// A <ClerkProvider> az App.tsx-be költözött (ClerkProviderWithRouter), a Router belsejébe.
// Itt NE legyen másik <ClerkProvider>!

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();